<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.25 3C5.3505 3 3 5.3505 3 8.25C3 11.1495 5.3505 13.5 8.25 13.5C11.1495 13.5 13.5 11.1495 13.5 8.25C13.5 5.3505 11.1495 3 8.25 3ZM1.5 8.25C1.5 4.52208 4.52208 1.5 8.25 1.5C11.9779 1.5 15 4.52208 15 8.25C15 11.9779 11.9779 15 8.25 15C4.52208 15 1.5 11.9779 1.5 8.25Z"
      fill="#F57E53"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.958 11.958C12.2508 11.6651 12.7257 11.6651 13.0186 11.958L16.2811 15.2204C16.574 15.5133 16.574 15.9882 16.2811 16.2811C15.9882 16.574 15.5133 16.574 15.2205 16.2811L11.958 13.0186C11.6651 12.7257 11.6651 12.2508 11.958 11.958Z"
      fill="#F57E53"
    />
  </svg>
</template>
